<template>
    <div class="row">
        <div class="col-1 text-center">
            <i class="material-icons notification-status" :class="[notificationClass]">
                {{status}}
            </i>
        </div>
        <div class="col-2 text-center small">
            <i class="material-icons">
                vertical_align_bottom
            </i>
            {{priority}}
        </div>
        <div class="col-4 handler">
            <i class="material-icons">
                {{type == 'email' ? 'alternate_email' : 'textsms'}}
            </i>
            {{handler}}
        </div>
        <div class="col-5">
            <span v-for="list in lists" class="list-name badge badge-success">
                {{list.name}}
            </span>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            handler: {
                type: String,
                required: true
            },
            lists: {
                type: Array,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            is_active: {
                type: Boolean,
                required: true
            },
            priority: {
                type: Number,
                required: true
            }
        },
        methods: {
            toggleContact(){
                if(this.$store.getters['auth/hasRole']('editor')){
                    this.toggled = !this.toggled
                }
            }
        },
        computed: {
            ... mapState('persons', ['search']),
            status(){
                return this.is_active ? 'notifications_active' : 'notifications_off'
            },
            notificationClass(){
                return this.is_active ? '' : 'text-danger'
            }
        }
    }
</script>

<style scoped>
.list-name{
    margin-right: 10px;
}
.notification-status{
    font-size: 20px;
    line-height: 20px;
}
</style>